import React from 'react';
import PropTypes from 'prop-types';

import GridBlock from '../GridBlock';
import GridSection from '../GridSection';
import GridPosition from '../GridPosition';

import styles from './index.styl';

export { GridBlock as Block };
export { GridSection as Section };
export { GridPosition as Position };

/**
 * Компонент, предоставляющий "полотно" для расположения атомов грида.
 * По умолчанию стремится занять 100% ширины контейнера, а при ограничении
 * своей ширины будет стараться расположиться по центру контейнера.
 */
export default function Grid(props) {
  return (
    <div
      className={styles.grid}
      style={{
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
      }}
    >
      {props.children}
    </div>
  );
}

Grid.propTypes = {
  /** @ignore */
  children: PropTypes.node,

  /**
   * Максимальная ширина блока-контейнера грида.
   */
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Минимальная ширина блока-контейнера грида.
   */
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

/**
 * Оставляем экспорт через статическое свойство в качестве обратой
 * совместимости, но лучше использовать нормальный ES6 экспорт.
 */
Grid.Block = GridBlock;
Grid.Section = GridSection;
Grid.Position = GridPosition;
